<script setup>

import { ref, defineComponent, onMounted } from "vue"; // <-- A futuro usar inject para helper o confGlobal
//import Conf from '@/Components/MainGlobal.vue';
import CardBoxModal from "@/Components/CardBoxModal.vue";
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeCheckbox from '@/Components/Checkbox.vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
//import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue';
import BreezeApplicationLogoFull from '@/Components/ApplicationLogoFull.vue';
import BreezeDropdown from '@/Components/Dropdown.vue';
import BreezeDropdownLink from '@/Components/DropdownLink.vue';
import BaseButton from "@/Components/BaseButton.vue";
import Footer from '@/Components/Footer.vue';
import { Inertia } from '@inertiajs/inertia';
import BreezeGuestLayout from '@/Layouts/Guest.vue';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';
import helpers from '../Common/helpers';
import SeoMeta from '@/Components/SeoMeta.vue';
//import helpers from inject('helpers');
// import helpers from inject('helpers'); // <-- Revisdar el injecct a futuro con confGlobal

import '@splidejs/vue-splide/css';

import BaseIcon from "@/Components/BaseIcon.vue";
import {
    mdiMagnify,
    mdiChevronDown,
    mdiAccountOutline,
    mdiCartOutline,
    mdiHeartOutline,
    mdiMenu,
    mdiCloseThick,
    mdiHeadset,
    mdiFacebook,
    mdiInstagram,
    mdiTwitter,
    mdiWhatsapp,
    mdiYoutube,
    mdiTruckFastOutline,
    mdiReload,
    mdiShieldLockOutline,
    mdiTrophyOutline,
    mdiArrowRight,
    mdiShoppingOutline,
    mdiStar,
    mdiArrowExpandAll,
    mdiRepeat,
    mdiChevronRight,
    mdiMinus,
    mdiPlus,
    mdiFlagVariant,
    mdiMoped,
    mdiPercent,
    mdiMailboxOutline,
    mdiArrowDownBold,
    mdiFilePdfBox,
    mdiLink,
    mdiAirplane,
    mdiArchivePlus

} from "@mdi/js";

const props = defineProps({
    canLogin: Boolean,
    canRegister: Boolean,
    laravelVersion: String,
    phpVersion: String,
    appVersion: String,
    contentWelcome: String,
    stocklabel: Number,
    accessParents: Boolean,
    object: Object,
    tallas: Array,
    categoryChild: Object,
    categoryParent: Object,
    brands: Object,
    //connstantes: Array
    urlNow: String,
    object: Object,
    seo: Object, // <--- ESTA LÍNEA ES VITAL
})




// Opcional: Una función simple para limpiar el HTML de la descripción en el cliente si es necesario
const cleanText = (text) => {
    return text ? text.replace(/<[^>]*>/g, '') : '';
};

// LRR
//const confGlobal = props.connstantes
/*const confGlobal = ref([])
onMounted(() => {
  let url = '/constante/global';
  axios.get(url).then(function (response) {
      var respuesta = response.data;
      confGlobal.value = respuesta.constantes;
      //console.log(me.constante);
    }).catch(function (error) {
        console.log(error);
  });
});
*/
//console.log( props.connstantes )

const form = useForm({
    email: '',
    nombre: '',
    phone: '',
    comment: '',
    recibirinfo: false
});
const isModalActive = ref(false);

//const stocklabel = ref(false)


// Información de Slide, limite x 4

const slidePrincipal = ref(null)
slidePrincipal.value = [
    { 'id': '01', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-1.png' },
    { 'id': '02', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-2.png' },
    { 'id': '03', 'label': 'Vr Box 3D Glass', 'referencia_producto': 'Explora nuestra colección tecnológica', 'ruta_imagen': '/img/slide/slide-3.png' },
]

const producto = ref(null)
producto.value = [
    { 'id': '20', 'sku': ' 100568', 'categoria': 'Computo / Monitores', 'label': 'Monitor LG 34GP63A-B UltraGear™ WQHD de 34"', 'precio_lista': '1799.00', 'precio': '1449.00', 'descuento': '25', 'moneda_simb': 'S/', 'envio_gratis': 1, 'rating': 5, 'stock': '0', 'ruta_imagen': '/img/productos/independiente/01.jpg', 'descripcion': 'Esto es una descripcion de Nota Publica', 'caracteristicas': 'Estas son caracteristicas del area de descripción del producto en el sistema Unens ERP', },
]

onMounted(() => {
    getData()
    getCart()
});

const products = ref([])
const getData = () => {
    let url = '/ecommerce/getproducts';
    let id_cat = props.object.categories[0] ? props.object.categories[0].id : 0;
    let params = {
        'limit': 6,
        'filterCatChild': id_cat, // origen es categoría
        'prodidOrigin': props.object.id
    }

    if (id_cat > 0) {
        //loading.value = true;
        axios.post(url, params).then((response) => {
            products.value = response.data;
            console.log('filter order ok');
        }).catch((error) => {
            console.log(error);
        });
        //loading.value = false;
    }
}

const qtyCart = ref(0)
const qtyProd = ref(1) // Aumentar product
const getCart = () => {
    let cart = []
    //let cartStorage = localStorage.getItem('cart')
    let cartStorage = sessionStorage.getItem('cart')
    if (cartStorage && cartStorage.length > 0) {
        cart = JSON.parse(cartStorage)
        qtyCart.value = cart.length
    }
    return cart
}

const addCart = (prodid = 0, cant = 1, ref = '', label = '', price = '') => {
    let cart = getCart()
    //let newObj = {'id': prodid, 'cant': cant}
    let newObj = { 'id': prodid, 'cant': cant, 'ref': ref, 'label': label, 'price': price }
    if (cart && cart.length > 0) {
        let obj = cart.find(o => o.id === prodid)
        if (obj !== undefined && obj !== null) {
            obj.cant += cant
        } else {
            cart.push(newObj)
        }
        sessionStorage.setItem('cart', JSON.stringify(cart))
        qtyCart.value = cart.length
        console.log('Upd Cart')
    } else {
        let newCart = [newObj]
        //localStorage.setItem('cart', JSON.stringify(newCart))
        sessionStorage.setItem('cart', JSON.stringify(newCart))
        qtyCart.value = newCart.length
        console.log('New Cart')
    }
    //emit('reload')

}

/* productosRelacionados.value = [
    { 'id': '28', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/01.jpg' },
    { 'id': '27', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 0, 'rating': 1, 'stock': '0', 'ruta_imagen': '/img/productos/02.jpg' },
    { 'id': '26', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 0, 'stock': '2', 'ruta_imagen': '/img/productos/03.jpg' },
    { 'id': '25', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/04.jpg' },
    { 'id': '24', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '1', 'ruta_imagen': '/img/productos/05.jpg' },
    { 'id': '23', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/06.jpg' },
    { 'id': '22', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/07.jpg' },
    { 'id': '21', 'label': 'Play Station 5 + Mando', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'popular': 1, 'rating': 5, 'stock': '4', 'ruta_imagen': '/img/productos/08.jpg' }
] */

const productosDestacados = ref(null)
productosDestacados.value = [
    { 'id': '31', 'label': 'Monitor Curvo Samsung 49″ WQLED LS49A950', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'rating': 5, 'ruta_imagen': '/img/productos/20.jpg' },
    { 'id': '32', 'label': 'Tablet Samsung Galaxy Tab S7 Fe 64gb', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'rating': 5, 'ruta_imagen': '/img/productos/21.jpg' },
    { 'id': '33', 'label': 'Asus ROG Strix RX5700 XT O8G 8GB', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'rating': 5, 'ruta_imagen': '/img/productos/22.jpg' },
    { 'id': '34', 'label': 'Impresora HP LaserJet 107W', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'rating': 5, 'ruta_imagen': '/img/productos/23.jpg' },
    { 'id': '35', 'label': 'Impresora Multifuncional Epson EcoTank L3110', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'rating': 5, 'ruta_imagen': '/img/productos/24.jpg' },
    { 'id': '36', 'label': 'Mochila Lenovo Thinkpad Professional G2', 'precio_lista': '550.00', 'precio': '450.00', 'moneda_simb': 'S/', 'rating': 5, 'ruta_imagen': '/img/productos/25.jpg' }
]

const marcasRelacionadas = ref(null)
marcasRelacionadas.value = [
    { 'id': '101', 'ruta_imagen': '/img/marcas/01.png' },
    { 'id': '102', 'ruta_imagen': '/img/marcas/02.png' },
    { 'id': '103', 'ruta_imagen': '/img/marcas/03.png' },
    { 'id': '104', 'ruta_imagen': '/img/marcas/04.png' },
    { 'id': '105', 'ruta_imagen': '/img/marcas/05.png' },
    { 'id': '106', 'ruta_imagen': '/img/marcas/06.png' },
    { 'id': '107', 'ruta_imagen': '/img/marcas/07.png' },
    { 'id': '108', 'ruta_imagen': '/img/marcas/08.png' },
    { 'id': '109', 'ruta_imagen': '/img/marcas/09.png' },
    { 'id': '110', 'ruta_imagen': '/img/marcas/10.png' },
    { 'id': '111', 'ruta_imagen': '/img/marcas/11.png' },
    { 'id': '112', 'ruta_imagen': '/img/marcas/12.png' }
]

const promociones = ref(null)
promociones.value = [
    { 'id': '250', 'ruta_imagen': '/img/promociones/01.png' },
    { 'id': '251', 'ruta_imagen': '/img/promociones/02.png' },
]

const marcas = ref(null)
marcas.value = [
    { 'id': '102', 'ruta_imagen': '/img/marcas/logos/acer.png' },
    { 'id': '101', 'ruta_imagen': '/img/marcas/logos/amd.png' },
    { 'id': '103', 'ruta_imagen': '/img/marcas/logos/apple.png' },
    { 'id': '104', 'ruta_imagen': '/img/marcas/logos/asus.png' },
    { 'id': '105', 'ruta_imagen': '/img/marcas/logos/cougar.png' },
    { 'id': '106', 'ruta_imagen': '/img/marcas/logos/gigabyte.png' },
    { 'id': '107', 'ruta_imagen': '/img/marcas/logos/hp.png' },
    { 'id': '108', 'ruta_imagen': '/img/marcas/logos/intel.png' },
    { 'id': '109', 'ruta_imagen': '/img/marcas/logos/lenovo.png' },
    { 'id': '110', 'ruta_imagen': '/img/marcas/logos/lg.png' },
    { 'id': '111', 'ruta_imagen': '/img/marcas/logos/nvidia.png' },
    { 'id': '112', 'ruta_imagen': '/img/marcas/logos/samsung.png' }
]

const tabs = ref(0)// Pordefecto ya no será 0;

const urlNow = ref(window.location.origin)


</script>

<!-- <script>

import { Splide, SplideSlide } from '@splidejs/vue-splide';
import GuestUnens from "@/Layouts/GuestUnens.vue";
export default defineComponent({
    name: 'ThumbnailsExample',

    components: {
        Splide,
        SplideSlide,
    },

    setup() {
        // const main = ref < InstanceType < typeof Splide >> ();
        // const thumbs = ref < InstanceType < typeof Splide >> ();
        const slides = generateSlides();


        onMounted(() => {
            const thumbsSplide = thumbs.value?.splide;

            if (thumbsSplide) {
                main.value?.sync(thumbsSplide);
            }
        });

        return {
            slides,
            main,
            thumbs,
            mainOptions,
            thumbsOptions,
        }
    },
});
</script> -->

<!-- CONEXIÓN DE CARRUSEL DE IMAGENES - THUMBNAIL -->
<!-- CONEXIÓN DE CARRUSEL DE IMAGENES - THUMBNAIL -->

<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import { defineComponent } from 'vue';
import '@splidejs/vue-splide/css';
// import '@splidejs/vue-splide/css/skyblue';


export default {
    mounted() {
        // Synchronize the main slider with the thumbnail slider
        this.$refs.main_computer.splide.sync(this.$refs.thumbnail_computer.splide);
        this.$refs.main_smartphone.splide.sync(this.$refs.thumbnail_smartphone.splide);
    },
}
</script>

<!-- CONEXIÓN DE CARRUSEL DE IMAGENES - THUMBNAIL -->
<!-- CONEXIÓN DE CARRUSEL DE IMAGENES - THUMBNAIL -->

<template>
    <!-- <Head>
        <title>{{ object ? object.label : 'Cargando producto...' }}</title>
        <meta name="description" :content="cleanText(object.description)" />
    </Head> -->
    <SeoMeta 
        :title="props.seo?.label" 
        :description="props.seo?.description" 
    />
    <!-- Head con categorías -->
    <BreezeGuestLayout :categoryChild="categoryChild" :categoryParent="categoryParent" :qtyCart="qtyCart">

        <!-- Modal -->

        <!--START PRODUCTO SOLITARIO -->
        <!--START PRODUCTO SOLITARIO -->
        <!--START PRODUCTO SOLITARIO -->
        <section class="py-8 lg:pt-20">
            <div class="mx-auto px-4 sm:px-6 lg:px-8 " v-if="object">
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
                    <!-- START IMAGEN PARA COMPUTADORA -->
                    <!-- START IMAGEN PARA COMPUTADORA -->
                    <div class="hidden lg:block">
                        <div class="col-span-2 lg:col-span-1">
                            <div class="relative">
                                <div class="splide-product">
                                    <Splide v-if="object.files.length > 0" :options="{ type: 'fade', rewind: true, pagination: false, perPage: 1, gap: 10, arrows: true, fixedHeight: 500 }" id="main-carousel" ref="main_computer" class="main mb-5 border">
                                        <SplideSlide v-for="(img, index) in object.files" :key="img.id">
                                            <img :src="(img.id ? '/documents/' + img.filepath + '/' + img.filename : '')" :alt="img.id ? img.name : object.label">
                                        </SplideSlide>
                                    </Splide>
                                    <div class="absolute left-[14px] top-[42px]">
                                        <div class="flex flex-col gap-2">
                                            <div v-if="object.list_price_ttc > object.price_ttc" class="flex">
                                                <div class="text-xs font-700 leading-none py-[5px] px-3 uppercase text-white rounded-full bg-rose-600 flex items-center">
                                                    <BaseIcon :path="mdiPercent" :size="18" class="mr-2" w="w-5" h="h-5"></BaseIcon><span>
                                                        {{ helpers.unensRound((object.list_price_ttc - object.price_ttc) * 100 / object.list_price_ttc) }} Dto.
                                                    </span>
                                                </div>
                                            </div>
                                            <div v-if="object.stockable_product == 1 && object.stock > 0" class="flex">
                                                <div class="text-xs font-700 leading-none py-[5px] px-3 uppercase text-white rounded-full bg-lime-500 flex items-center">
                                                    <BaseIcon :path="mdiMoped" :size="18" class="mr-2" w="w-5" h="h-5"></BaseIcon><span> Envio Inmediato
                                                    </span>
                                                </div>
                                            </div>
                                            <div v-if="object.stockable_product == 2" class="flex">
                                                <div class="text-xs font-700 leading-none py-[5px] px-3 uppercase text-white rounded-full bg-blue-600 flex items-center">
                                                    <BaseIcon :path="mdiArchivePlus" :size="18" class="mr-2" w="w-5" h="h-5"></BaseIcon><span> A pedido
                                                    </span>
                                                </div>
                                            </div>
                                            <div v-if="object.stockable_product == 3" class="flex">
                                                <div class="text-xs font-700 leading-none py-[5px] px-3 uppercase text-white rounded-full bg-violet-500 flex items-center">
                                                    <BaseIcon :path="mdiAirplane" :size="18" class="mr-2" w="w-" h="h-5"></BaseIcon><span>En transito
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <Splide v-if="object.files.length > 0" :options="{ fixedHeight: 90, perPage: 5, gap: 10, rewind: true, pagination: false, isNavigation: true, arrows: false, rewind: false, drag: 'free', }" id="thumbnail-carousel" ref="thumbnail_computer" class="thumbnail">
                                        <SplideSlide v-for="(img, index) in object.files" :key="img.id">
                                            <img :src="(img.id ? '/documents/' + img.filepath + '/' + img.filename : '')" :alt="img.id ? img.name : object.label">
                                        </SplideSlide>
                                        <!-- <SplideSlide>
                                            <img src="/img/productos/independiente/02.jpg" alt="Sample 2">
                                        </SplideSlide>
                                        <SplideSlide>
                                            <img src="/img/productos/independiente/03.jpg" alt="Sample 2">
                                        </SplideSlide>

                                        <SplideSlide>
                                            <img src="/img/productos/independiente/04.jpg" alt="Sample 2">
                                        </SplideSlide>
                                        <SplideSlide>
                                            <img src="/img/productos/independiente/05.jpg" alt="Sample 2">
                                        </SplideSlide> -->

                                    </Splide>


                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- END IMAGEN PARA COMPUTADORA -->
                    <!-- END IMAGEN PARA COMPUTADORA -->
                    <div class="">
                        <div class="w-full"><span class="text-xs font-normal uppercase mb-2 inline-block">{{ object.categories[0] ? object.categories[0].label : '' }}</span>
                            <p v-if="object.brand" class="text-gray-600 text-sm"><span class="text-gray-900 font-semibold"></span> {{ (object.brand ? ' ' + object.brand.label : '') }}</p>
                            <p class="text-2xl font-semibold text-gray-800 mb-4">{{ object.label }}</p>
                            <!-- START IMAGEN PARA CELULAR -->
                            <!-- START IMAGEN PARA CELULAR -->
                            <div class="block lg:hidden w-full">
                                <div class="w-full relative mb-3">
                                    <div class="splide-product splide-product-color">
                                        <Splide v-if="object.files.length > 0" :options="{ type: 'fade', rewind: true, pagination: false, perPage: 1, gap: 10, arrows: true, fixedHeight: 500 }" id="main-carousel" ref="main_smartphone" class="main">
                                            <SplideSlide v-for="(img, index) in object.files" :key="img.id">
                                                <img :src="(img.id ? '/documents/' + img.filepath + '/' + img.filename : '')" :alt="img.id ? img.name : object.label">
                                            </SplideSlide>
                                        </Splide>
                                        <div class="absolute left-[14px] top-[28px]">
                                            <div class="flex flex-col gap-2">
                                                <div v-if="object.list_price_ttc > object.price_ttc" class="flex">
                                                    <div class="text-xs font-700 leading-none py-[5px] px-3 uppercase text-white rounded-full bg-rose-600 flex items-center">
                                                        <BaseIcon :path="mdiPercent" :size="18" class="mr-2" w="w-5" h="h-5"></BaseIcon><span>
                                                            {{ helpers.unensRound((object.list_price_ttc - object.price_ttc) * 100 / object.list_price_ttc) }} Dto.
                                                        </span>
                                                    </div>
                                                </div>
                                                <div v-if="object.stockable_product == 1 && object.stock > 0" class="flex">
                                                    <div class="text-xs font-700 leading-none py-[5px] px-3 uppercase text-white rounded-full bg-lime-500 flex items-center">
                                                        <BaseIcon :path="mdiMoped" :size="18" class="mr-2" w="w-5" h="h-5"></BaseIcon><span> Envio Inmediato
                                                        </span>
                                                    </div>
                                                </div>
                                                <div v-if="object.stockable_product == 2" class="flex">
                                                    <div class="text-xs font-700 leading-none py-[5px] px-3 uppercase text-white rounded-full bg-blue-600 flex items-center">
                                                        <BaseIcon :path="mdiArchivePlus" :size="18" class="mr-2" w="w-5" h="h-5"></BaseIcon><span> A pedido
                                                        </span>
                                                    </div>
                                                </div>
                                                <div v-if="object.stockable_product == 3" class="flex">
                                                    <div class="text-xs font-700 leading-none py-[5px] px-3 uppercase text-white rounded-full bg-violet-500 flex items-center">
                                                        <BaseIcon :path="mdiAirplane" :size="18" class="mr-2" w="w-" h="h-5"></BaseIcon><span>En transito
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <Splide v-if="object.files.length > 0" :options="{ fixedHeight: 90, perPage: 5, gap: 10, rewind: true, pagination: false, isNavigation: true, arrows: false, rewind: false, drag: 'free' }" id="thumbnail-carousel" ref="thumbnail_smartphone" class="thumbnail">
                                            <SplideSlide v-for="(img, index) in object.files" :key="img.id">
                                                <img :src="(img.id ? '/documents/' + img.filepath + '/' + img.filename : '')" :alt="img.id ? img.name : object.label">
                                            </SplideSlide>
                                        </Splide>
                                    </div>
                                </div>
                            </div>
                            <!-- END IMAGEN PARA CELULAR -->
                            <!-- END IMAGEN PARA CELULAR -->
                            <div class="flex items-center justify-between mb-6">
                                <div>
                                    <p class="text-gray-600 text-sm"><span class="text-gray-900 font-semibold">SKU:</span> {{ object.ref }}</p>

                                </div>
                            </div>

                            <div class="flex flex-col lg:flex-row lg:space-x-2 lg:items-center lg:justify-between">
                                <div class="mb-2 lg:mb-0">
                                    <span class="text-2xl font-semibold text-color">
                                        {{ helpers.currencySymbol(confGlobal.value.COMPANY_MULTICURRENCY_CODE) }} {{ object.price_ttc }}
                                    </span>
                                    <span v-if="(object.list_price_ttc > 0)" class="text-base line-through text-gray-600 mt-2 ml-2">
                                        {{ helpers.currencySymbol(confGlobal.value.COMPANY_MULTICURRENCY_CODE) }} {{ object.list_price_ttc }}
                                    </span>
                                </div>
                                <div>
                                    <template v-if="Object.keys(confGlobal.value).length > 0">
                                        <p v-if="object.stock <= 0 && confGlobal.value.PRODUCT_STOCK_ZERO_LABEL" class="text-gray-800 text-sm">
                                            <span class="font-semibold">{{ confGlobal.value.PRODUCT_STOCK_ZERO_LABEL }}</span>
                                        </p>
                                        <p v-else class="text-gray-800 text-sm">
                                            Stock: <span class="font-semibold">{{ (stocklabel ? (object.stock > parseInt(stocklabel) ? 'Disponible' : 'Limitado') : (object.stock > parseInt(confGlobal.value.PRODUCT_STOCK_LABEL || 30) ? '+ ' + (confGlobal.value.PRODUCT_STOCK_LABEL || '30') : object.stock)) }}</span>
                                        </p>
                                    </template>
                                </div>
                            </div>
                            <hr class="my-4">
                            <div>
                                <div>
                                    <p class="block text-xs text-gray-800 mb-1">
                                        Seleccione cantidad
                                    </p>
                                </div>
                                <div class="flex flex-col lg:flex-row gap-4">
                                    <div class="mb-2 lg:mb-0 w-full lg:w-[200px] relative">
                                        <div class="relative">
                                            <button class="btn-color absolute h-[30px] w-[30px] right-10 top-1 my-auto p-1 flex items-center rounded" type="button" @click="(qtyProd -= 1)">
                                                <BaseIcon :path="mdiMinus" :size="20" class="text-white" w="w-5" h="h-5"></BaseIcon>
                                            </button>
                                            <input type="number" id="qtyProd" class="pl-4 h-[38px] p-2 text-sm  border-gray-200 hover:border-gray-200 focus:border-blue-300 bg-transparent font-semibold w-full focus:ring-4 focus:ring-blue-300/50 transition-transform ease-out duration-300" placeholder="01" v-model="qtyProd" />
                                            <button class="btn-color absolute h-[30px] w-[30px] right-1 top-1 my-auto p-1 flex items-center rounded" type="button" @click="(qtyProd += 1)">
                                                <BaseIcon :path="mdiPlus" :size="20" class="text-white" w="w-5" h="h-5"></BaseIcon>
                                            </button>
                                        </div>
                                    </div>
                                    <div>
                                        <button type="button" class="lg:w-auto w-full btn btn-color flex justify-center" @click="addCart(object.id, qtyProd, object.ref, object.label, object.price_ttc)">
                                            <div class="flex items-center space-x-3">
                                                <BaseIcon :path="mdiShoppingOutline" :size="24" class="text-white" w="w-4" h="h-4"></BaseIcon>
                                                <span>Agregar al carrito</span>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <hr class="my-4">
                            <div class="mb-4 p-2 border rounded-md">
                                <div class="flex flex-wrap gap-2 mb-2 pb-2 border-b">
                                    <button @click="(tabs = 0)" class="rounded-md text-sm px-3 py-2 focus:ring-4 focus:outline-none border" :class="[tabs == 0 ? 'btn-color' : 'btn-light']">
                                        Caracteristicas
                                    </button>
                                    <button @click="(tabs = 1)" class="rounded-md text-sm px-3 py-2 focus:ring-4 focus:outline-none border" :class="[tabs == 1 ? 'btn-color' : 'btn-light']">
                                        Descargas
                                    </button>
                                </div>
                                <div v-show="tabs == 0" class="py-2 max-h-[210px] overflow-y-auto">
                                    <ul class="list-disc">
                                        <div v-html="object.description"></div>
                                    </ul>
                                </div>
                                <div v-show="tabs == 1" class="py-2 max-h-[160px] overflow-y-auto">
                                    <ul class="list-disc space-y-2" v-if="object.links.length">
                                        <li v-for="(item, index) in object.links" :key="index">
                                            <div class="flex items-center justify-between">
                                                <div>{{ item.label }}</div>
                                                <div>
                                                    <a :href="item.url" target="_blank">
                                                        <button class="flex items-center btn-icon btn-rose">
                                                            <!-- mdiArrowDownBold item.url.slice(-5, -4) -->
                                                            <BaseIcon :path="(item.url.slice(-4) == '.pdf' ? mdiFilePdfBox : mdiLink)" :size="24" class="text-white" w="w-5" h="h-5"></BaseIcon>
                                                        </button>
                                                    </a>

                                                </div>
                                            </div>
                                        </li>
                                    </ul>

                                </div>
                            </div>
                            <div class="flex items-center space-x-4">
                                <button v-if="!qtyCart && (object.stockable_product == 2 || object.stock == 0)" type="button" class="lg:w-auto w-full btn btn-color btn-ico flex justify-center">
                                    <Link :href="route('eco-infoaddress', { id: object.id, qty: qtyProd, cot: 1 })">
                                        <div class="flex items-center space-x-3">
                                            <BaseIcon :path="mdiMailboxOutline" :size="24" class="text-white" w="w-5" h="h-5"></BaseIcon>
                                            <span>Solicitar cotización</span>
                                        </div>
                                    </Link>
                                </button>
                                <!-- <button type="button" class="lg:w-auto w-full btn btn-color btn-ico flex justify-center h-[38px]">
                                    <div class="flex items-center space-x-3">
                                        <BaseIcon :path="mdiMailboxOutline" :size="24" class="text-white" w="w-5" h="h-5"></BaseIcon>
                                        <span>Solicitar cotización</span>
                                    </div>
                                </button> -->
                            </div>
                            <!-- <div class="flex space-x-2 items-center aos-init">
                                <a :href="'mailto:' + confGlobal.value.COMPANY_MAIL" class="text-red-500 hover:text-red-700 font-semibold text-xs flex items-center">
                                    <BaseIcon :path="mdiFlagVariant" :size="22" class="pr-2" w="w-5" h="h-5"></BaseIcon> Reportar consulta
                                </a>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div v-if="object.public_note" class="grid grid-cols-1 gap-8">
                    <div class="col-span-1">
                        <h1>Descripción adicional</h1>
                    </div>
                    <div v-html="object.public_note"></div>
                </div>
            </div>
        </section>
        <!--END PRODUCTO SOLITARIO -->
        <!--END PRODUCTO SOLITARIO -->
        <!--END PRODUCTO SOLITARIO -->




        <!-- START PRODUCTOS DE CATEGORIA -->
        <!-- START PRODUCTOS DE CATEGORIA -->
        <!-- START PRODUCTOS DE CATEGORIA -->
        <section v-if="object.categories[0]" class="py-8">
            <div class="mx-auto px-4 sm:px-6 lg:px-8">
                <div class="flex justify-between items-center mb-5">
                    <div>
                        <h1 class="sm:text-3xl text-xl font-600 leading-none">Productos Relacionados</h1>
                    </div>
                    <div>
                        <Link :href="route('eco-product-category', { id: object.categories[0].id })">
                            <div class="flex space-x-2 items-center">
                                <p class="text-base font-600 hidden lg:block hover:text-color text-gray-900">Ver Más</p>
                                <span>
                                    <BaseIcon :path="mdiArrowRight" :size="32" class=" icon-color" w="w-12" h="h-12"></BaseIcon>
                                </span>
                            </div>

                        </Link>
                    </div>
                </div>
                <div v-if="products.length > 0">
                    <div class="w-full">
                        <div class="sm:grid-cols-1 xl:col-span-8 h-full">
                            <div class="w-full grid lg:grid-cols-2 xl:grid-cols-3 grid-cols-1 gap-4 h-full">
                                <div class="h-1/3 col-span-1" v-for="(item, index) in products" :key="item.id">
                                    <div class="w-full h-[210px] bg-white group relative overflow-hidden rounded-lg border shadow-xl shadow-gray-400/10">
                                        <div class="flex lg:gap-4 gap-2 items-center w-full h-full p-2 lg:p-4">
                                            <div class="relative lg:w-1/2 w-1/3 h-full">
                                                <Link :href="route('eco-product-show', { id: item.id })">
                                                    <img :src="(item.files[0] ? '/documents/' + item.files[0].filepath + '/' + item.files[0].filename : '')" class="w-full h-full object-contain">

                                                    <div class="absolute left-[0px] bottom-[10px]">
                                                        <!-- <div v-if="item.stockable_product == 1 && item.stock > 0" class="flex"> -->
                                                        <div class="flex">
                                                            <div class="text-xs font-700 leading-none py-1 px-1 uppercase text-white rounded-full bg-lime-500 flex items-center">
                                                                <BaseIcon :path="mdiMoped" :size="18" w="w-5" h="h-5"></BaseIcon><span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </Link>

                                                <div class="absolute left-[0px] top-[10px]">
                                                    <div class="flex flex-col gap-1">
                                                        <div v-if="item.list_price_ttc > item.price_ttc" class="flex">
                                                            <div class="text-[10px] lg:text-xs font-700 leading-none py-[5px] px-3 uppercase text-white rounded-full bg-rose-600 flex items-center">
                                                                <span>
                                                                    {{ helpers.unensRound((item.list_price_ttc - item.price_ttc) * 100 / item.list_price_ttc) }} Dto.
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div v-if="item.stockable_product == 2" class="flex">
                                                            <div class="text-[10px] lg:text-xs font-700 leading-none py-[5px] px-3 uppercase text-white rounded-full bg-blue-600 flex items-center">
                                                                <span> A pedido
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div v-if="item.stockable_product == 3" class="flex">
                                                            <div class="text-[10px] lg:text-xs font-700 leading-none py-[5px] px-3 uppercase text-white rounded-full bg-violet-500 flex items-center">
                                                                <span>En transito
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                            <div class="flex-1 flex flex-col justify-center h-full">
                                                <div>
                                                    <div class="limit-line line-2">
                                                        <p class="mb-2 sm:text-sm text-xs font-semibold leading-[24px] line-clamp-2 hover:text-color">
                                                            <Link :href="route('eco-product-show', { id: item.id })">{{ item.label }}</Link>
                                                        </p>
                                                    </div>

                                                    <p class="mb-4">
                                                        <span class="font-semibold text-gray-800 text-base">
                                                            {{ helpers.currencySymbol(confGlobal.value.COMPANY_MULTICURRENCY_CODE) }} {{ item.price_ttc }}
                                                        </span>
                                                        <span v-if="(item.list_price_ttc > 0)" class="line-through font-600 text-gray-500 text-sm ml-2">
                                                            {{ helpers.currencySymbol(confGlobal.value.COMPANY_MULTICURRENCY_CODE) }} {{ item.list_price_ttc }}
                                                        </span>
                                                    </p>
                                                    <button type="button" class="btn btn-color btn-ico flex justify-center" @click="addCart(item.id, 1, item.ref, item.label, item.price_ttc)">
                                                        <div class="flex items-center space-x-2 md:space-x-0 2xl:space-x-3">
                                                            <BaseIcon :path="mdiShoppingOutline" class="text-white" :size="24" w="w-4" h="h-4"></BaseIcon>
                                                            <span>Agregar al carrito</span>
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- END PRODUCTOS DE CATEGORIA  -->
        <!-- END PRODUCTOS DE CATEGORIA  -->
        <!-- END PRODUCTOS DE CATEGORIA  -->


        <!--START MARCAS -->
        <!--START MARCAS -->
        <!--START MARCAS -->

        <section class="py-8">
            <div class="mx-auto px-4 sm:px-6 lg:px-8">
                <div class="flex justify-between items-center mb-5">
                    <div>
                        <h1 class="sm:text-3xl text-xl font-600 leading-none">Marcas que ofrecemos</h1>
                    </div>
                    <div>
                        <Link :href="route('eco-brands')">
                            <div class="flex space-x-2 items-center">
                                <p class="text-base font-600 hidden lg:block a-color">Ver Más</p>
                                <span>
                                    <BaseIcon :path="mdiArrowRight" :size="32" class="icon-color" w="w-12" h="h-12"></BaseIcon>
                                </span>
                            </div>
                        </Link>
                    </div>
                </div>
                <div class="relative slider-marcas slider-marcas-color" v-if="brands.length > 0">
                    <hr class="my-4">
                    <Splide :has-track="true" :options="{ rewind: 'true', perMove: 1, type: 'loop', autoplay: true, pagination: false, arrows: true, gap: '1em', mediaQuery: 'min', breakpoints: { 1820: { perPage: 7 }, 1536: { perPage: 6 }, 1023: { perPage: 4 }, 640: { perPage: 2 }, 0: { perPage: 1 } } }" class="rounded-md" id="">
                        <SplideSlide class="rounded-md w-full h-full " v-for="(item, index) in brands" :key="item.id">
                            <div class="w-full h-[110px] lg:h-[150px] marca">
                                <Link :href="route('eco-product-category', { id: 0, label: '', originbrand: item.id })" class="">
                                    <img :src="(item.files[0] ? '/documents/' + item.files[0].filepath + '/' + item.files[0].filename : '')" class="hover:grayscale h-14 xl:h-20 !object-contain transition-all ease-in-out duration-500">
                                </Link>
                            </div>
                        </SplideSlide>
                    </Splide>
                    <hr class="my-4">
                </div>
            </div>
        </section>
        <!-- END MARCAS -->
        <!-- END MARCAS -->
        <!-- END MARCAS -->



        <!-- START PROMOCIONES -->
        <!-- START PROMOCIONES -->
        <!-- START PROMOCIONES -->
        <!-- <section class="py-8">
            <div class="container mx-auto px-4 sm:px-6 lg:px-8" v-if="promociones.length > 0">
                <div class="flex justify-between items-center mb-5">
                    <div>
                        <h1 class="sm:text-3xl text-xl font-600 leading-none">Ultimas Promociones</h1>
                    </div>
                    <div>
                        <a href="#">
                            <div class="flex space-x-2 items-center">
                                <p class="text-base font-600 hidden lg:block a-color">Ver Más</p>
                                <span>
                                    <BaseIcon :path="mdiArrowRight" :size="32" class="icon-color" w="w-12" h="h-12"></BaseIcon>
                                </span>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    <div class="col-span-1 bg-white shadow-xl shadow-gray-400/10 rounded-lg" v-for="(item, index) in promociones" :key="item.id">
                        <div class="rounded-md overflow-hidden block">
                            <a href="#">
                                <img :src="item.ruta_imagen" alt="" class="hover:scale-110 ease-in duration-500 w-full">
                            </a>
                        </div>
                    </div>

                </div>
            </div>
        </section> -->
        <!-- END PROMOCIONES -->
        <!-- END PROMOCIONES -->
        <!-- END PROMOCIONES -->


        <!-- 
        <h1>HOLA</h1>
        <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div class="grid grid-cols-2">
                <div class="col-span-1">
                    <div id="thumbnail-slider" class="splide">
                        <div class="splide__track">
                            <ul class="splide__list">
                                <li class="splide__slide">
                                    <img src="/img/productos/independiente/01.jpg">
                                </li>
                                <li class="splide__slide">
                                    <img src="/img/productos/independiente/02.jpg">
                                </li>
                                <li class="splide__slide">
                                    <img src="/img/productos/independiente/03.jpg">
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->


        <!-- <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div class="grid grid-cols-2">
                <div class="col-span-2 lg:col-span-1 product-thumbnails">
                   
                    <Splide :options="{
                        type: 'fade',
                        rewind: true,
                        pagination: false,
                        // cover: true,
                        perPage: 1, 
                        gap: 10,
                        arrows: true,
                        fixedHeight: 500,
                    }" id="main-carousel" ref="main" class="mb-5 border"> 
                        <SplideSlide>
                            <img src="/img/productos/independiente/01.jpg" alt="Sample 1">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/02.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/03.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/04.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide >
                            <img src="/img/productos/independiente/05.jpg" alt="Sample 2">
                        </SplideSlide>
                    </Splide>

                    <Splide :options="{
                        // fixedWidth: 100,
                        fixedHeight: 90,
                        perPage: 5, 
                        // gap: 10,
                        rewind: true,
                        pagination: false,
                        cover: true,
                        isNavigation: true,
                        arrows: false,
                        rewind: false,
                        drag: 'free',
                        // focus: 'center',
                        // breakpoints: {
                        //     600: {
                        //         fixedWidth: 60,
                        //         fixedHeight: 44,
                        //     },
                        // },
                    }" id="thumbnail-carousel" ref="thumbnail">
                        <SplideSlide>
                            <img src="/img/productos/independiente/01.jpg" alt="Sample 1">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/02.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/03.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide>
                            <img src="/img/productos/independiente/04.jpg" alt="Sample 2">
                        </SplideSlide>
                        <SplideSlide >
                            <img src="/img/productos/independiente/05.jpg" alt="Sample 2">
                        </SplideSlide>
                    </Splide>
                </div>
            </div>

        </div> -->


    </BreezeGuestLayout>
</template>

<style scoped>
.splide__slide img {

    object-fit: cover;
}
</style>
